import { notEmpty } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { ArticleMoreStoriesItem } from "scmp-app/components/article/article-more-stories/article-more-stories-item";
import type { articleMoreStoriesArticle$key } from "scmp-app/queries/__generated__/articleMoreStoriesArticle.graphql";

export type Props = {
  className?: string;
  reference: articleMoreStoriesArticle$key;
};
import { ArticleMoreStoriesItems, StyledArticleMoreStories, Title } from "./styles";

export const ArticleMoreStories: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const { moreOnThisArticles } = useFragment(
    graphql`
      fragment articleMoreStoriesArticle on Article {
        moreOnThisArticles {
          entityId
          ...articleMoreStoriesItemArticle
        }
      }
    `,
    reference_,
  );

  const articles = moreOnThisArticles?.filter(notEmpty);
  if (!articles?.length) return null;

  return (
    <StyledArticleMoreStories>
      <Title>MORE STORIES</Title>
      <ArticleMoreStoriesItems>
        {articles.slice(0, 3).map(article => (
          <ArticleMoreStoriesItem key={article.entityId} reference={article} />
        ))}
      </ArticleMoreStoriesItems>
    </StyledArticleMoreStories>
  );
};

ArticleMoreStories.displayName = "ArticleMoreStories";
